(<template>
  <div v-if="$session.exists() && $route.path !=='/'">
    <transition name="el-fade-in-linear">
      <div v-show="show" class="comment-div">
        <h2 class="comment-maintitle"><span v-translate>Comments</span>&emsp;</h2>
        <hr class="delimiter">
        <div class="comment-list">
          <el-card v-for="comment in commentList" :key="comment.id" :body-style="{ padding: '0px' }">
            <div class="comment-title" slot="header">
              <span class="comments-user-icon" :style="{background: getColor(comment.createdBy)}">
                {{comment.createdBy[0].toUpperCase()}}
              </span>
              <div>
                <strong class="comment-title-content">{{comment.createdBy}}</strong>
                <br />
                <span class="comment-title-content">{{getDateTime(comment.date)}}</span>
                <br />
                <a class="comment-title-content"
                   :href="getMonumentUrl(comment.monumentId)"
                   target="_blank">{{comment.monumentName[$language.current]}}</a>
              </div>
            </div>
            <p class="comment-content">
              {{comment.comment}}
            </p>
          </el-card>
        </div>
      </div>
    </transition>
    <el-button @click="show=!show" id="left-hide-button" size="mini">
      <div id="vertical-left">
        <span v-translate>Comments</span>
      </div>
    </el-button>
  </div>

</template>)

(<script>
import axios from 'axios'
import StringToColor from 'string-to-color'

export default {
  name: 'comment-newsfeed',
  data () {
    return {
      commentList: [],
      show: true
    }
  },
  created () {
    this.getCommentList()
  },
  methods: {
    getMonumentUrl (id) {
      return `/#/monuments/${id}`
    },
    getColor (string) {
      return `#${StringToColor.generate(string)}`
    },
    getDateTime (dateString) {
      var now = new Date()
      var date = new Date(dateString)
      if (now.getFullYear() === date.getFullYear() && now.getMonth() === date.getMonth() && now.getDate() === date.getDate()) {
        return date.toTimeString().split(' ')[0]
      } else {
        return dateString.slice(0, 10).replace(/-/g, ' ')
      }
    },
    getCommentList () {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/comments`,
        withCredentials: true
      })
      .then(response => {
        this.commentList = response.data
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    }
  }
}
</script>)

(<style>
#vertical-left {
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
}
.comment-div {
  float: left;
  background-color: #bde5ef;
  width: 20%;
  padding-bottom: 1em;
  padding-left: 1em;
  padding-right: 1em;
  left: 2em;
  display: inline-block;
  position: absolute;
  top: 8em;
  height: 70vh;
}
.comment-title {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  line-height: 1.3em;
  text-align: left;
}
.comment-maintitle {
  font-size: 120%;
  text-align: center;
  padding: 0.5em;
}
.comment-title-content {
  padding: 0.5em;
}
.comment-list {
  overflow-y: scroll;
  height: 85%;
}
.comments-user-icon {
  width: 2em;
  height: 2em;
  line-height: 2em;
  display: block;
  border-radius: 50%;
  text-align: center;
  color: white;
}
#left-hide-button {
  position: fixed;
  left: 0px;
  top: 0px;
  height: 100vh;
  width: 1em;
}
.center {
  text-align: center;
}
@media screen and (max-width: 1200px) {
  .comment-div {
    position: relative;
    top: 2em;
    margin-bottom: 8em;
    width: 40%;
  }
  .comment-list {
    overflow-y: scroll;
    height: 20em;
  }
}
</style>)



// WEBPACK FOOTER //
// src/components/Comments-Newsfeed.vue